import { BUY_TO_LET_FLOW } from '@app/sign-up/constants/buy-to-let-flow';
import { ENTRY_FLOW } from '@app/sign-up/constants/entry-flow';
import { LANDLORD_FLOW } from '@app/sign-up/constants/landlord-flow';
import { MORTGAGE_MONITOR_FLOW } from '@app/sign-up/constants/mortgage-monitor-flow';
import { REMORTGAGE_NOW_FLOW } from '@app/sign-up/constants/remotgage-now-flow';
import { FlowStepsModel } from '@app/sign-up/models/flow-step.model';
import { FIRST_TIME_BUYER_FLOW } from '@shared-lib/constants/sign-up/first-time-buyer-flow';
import { MOVING_HOME_FLOW } from '@shared-lib/constants/sign-up/moving-home-flow';

export type Flow =
  | typeof MORTGAGE_MONITOR_FLOW
  | typeof FIRST_TIME_BUYER_FLOW
  | typeof ENTRY_FLOW
  | typeof LANDLORD_FLOW
  | typeof BUY_TO_LET_FLOW
  | typeof MOVING_HOME_FLOW
  | typeof REMORTGAGE_NOW_FLOW;

export type FlowSteps =
  | FlowStepsModel<typeof MORTGAGE_MONITOR_FLOW>
  | FlowStepsModel<typeof FIRST_TIME_BUYER_FLOW>
  | FlowStepsModel<typeof ENTRY_FLOW>
  | FlowStepsModel<typeof LANDLORD_FLOW>
  | FlowStepsModel<typeof BUY_TO_LET_FLOW>
  | FlowStepsModel<typeof MOVING_HOME_FLOW>
  | FlowStepsModel<typeof REMORTGAGE_NOW_FLOW>;

export const signUpFlowSelectorName = 'signUpFlow';
